'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('property-edit', {
      url: '/property/edit/:id',
      template: '<property-edit></property-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/property-edit/property-edit.routes.js